import { InvestmentWorkflowStatus } from '@dealstack/shared/lib/generated';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export interface InvestmentStatusBadge {
	text: string;
	color: string;
	textColor: string;
}

/**
 * Single source of truth for how an investment's status is displayed (label +
 * colour). Shared by the Investment Details summary card and the Investment
 * List "Status" column so the two always render identically.
 */
export const getInvestmentStatusBadge = (
	status: InvestmentWorkflowStatus,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>,
	mode: 'light' | 'dark'
): InvestmentStatusBadge => {
	const badges: Record<InvestmentWorkflowStatus, InvestmentStatusBadge> = {
		[InvestmentWorkflowStatus.OPEN]: {
			color: 'gray.4',
			textColor: mode === 'light' ? 'dark.4' : 'gray.4',
			text: tMipManage('investment_summary_card.investment_status.draft'),
		},
		[InvestmentWorkflowStatus.DEFINITION_COMPLETE]: {
			color: mode === 'light' ? 'cyan.8' : 'cyan.2',
			textColor: mode === 'light' ? 'cyan.8' : 'cyan.2',
			text: tMipManage('investment_summary_card.investment_status.approved'),
		},
		[InvestmentWorkflowStatus.IN_PROGRESS]: {
			color: mode === 'light' ? 'orange.8' : 'orange.4',
			textColor: mode === 'light' ? 'orange.8' : 'orange.4',
			text: tMipManage('investment_summary_card.investment_status.in_progress'),
		},
		[InvestmentWorkflowStatus.COMPLETE]: {
			color: mode === 'light' ? 'blue.6' : 'blue.4',
			textColor: mode === 'light' ? 'blue.6' : 'blue.4',
			text: tMipManage('investment_summary_card.investment_status.complete'),
		},
		[InvestmentWorkflowStatus.RELEASED]: {
			color: mode === 'light' ? 'teal.8' : 'teal.2',
			textColor: mode === 'light' ? 'teal.8' : 'teal.2',
			text: tMipManage('investment_summary_card.investment_status.released'),
		},
	};

	return badges[status];
};
